import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomBannerComponent } from './banner.component';
import { CmsConfig, FeaturesConfigModule, provideConfig } from '@spartacus/core';
import { RouterModule } from '@angular/router';
import { GenericLinkModule } from '@spartacus/storefront';
import { CustomMediaModule } from '../../media/media.module';

@NgModule({
  imports: [CommonModule, RouterModule, GenericLinkModule, CustomMediaModule, FeaturesConfigModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        SimpleResponsiveBannerComponent: {
          component: CustomBannerComponent,
        },
        BannerComponent: {
          component: CustomBannerComponent,
        },
        SimpleBannerComponent: {
          component: CustomBannerComponent,
        },
      },
    }),
  ],
  declarations: [CustomBannerComponent],
  exports: [CustomBannerComponent],
})
export class CustomBannerModule {}
